import { jsx } from "react/jsx-runtime";
import UndoIcon from "@mui/icons-material/Undo";
import { validateTidalLicense } from "../../base/index.js";
function Undo(props) {
  return /* @__PURE__ */ jsx(
    UndoIcon,
    {
      "data-testid": "Undo",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Undo",
      "data-tidal-icon-meta": "arrows"
    }
  );
}
Undo.tidalIconMeta = {
  categories: "arrows",
  name: "Undo"
};
validateTidalLicense();
export {
  Undo
};
//# sourceMappingURL=Undo.js.map
